import { AccountCircleOutlined, CalendarToday, DescriptionOutlined } from '@mui/icons-material';
export const iconMap: Record<string, React.ElementType> = {
  CalendarToday,
  AccountCircleOutlined,
  DescriptionOutlined
};
export const navigationItems = [{
  title: 'Appointments',
  icon: 'CalendarToday',
  redirect: '/patient-services/appointment/'
}, {
  title: 'Account Information',
  icon: 'AccountCircleOutlined',
  redirect: '/patient-services/account-information/'
}, {
  title: 'Documents & records',
  icon: 'DescriptionOutlined',
  redirect: '/patient-services/documents-and-records'
}];
export const routeMatchMap: Record<string, string[]> = {
  Appointments: ['/patient-services/appointment', '/patient-services/reschedule', '/patient-services/cancel', '/patient-services/confirm'],
  'Account Information': ['/patient-services/account-information'],
  'Documents & records': ['/patient-services/documents-and-records']
};
export const matchRouteWithItem = (title: string, pathname: string): boolean => {
  const pathsToMatch = routeMatchMap[title];
  return pathsToMatch.some(path => pathname.includes(path));
};